
import { Button } from '../../../components/base/Button';

export function HeroSection() {
  const handleScrollToProducts = () => {
    const productsSection = document.getElementById('products');
    if (productsSection) {
      productsSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleScrollToCEO = () => {
    const ceoSection = document.getElementById('ceo-section');
    if (ceoSection) {
      ceoSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      id="home" 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/923b5d834350a949392f76452b43272d.jpg')`
      }}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center text-white">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
            Where Technology<br />
            <span className="text-emerald-400">Meets Nature</span>
          </h2>
          <p className="text-xl md:text-2xl mb-8 text-gray-200 leading-relaxed">
            자연의 치유력과 과학의 정밀함이 만나,<br />
            피부와 마음이 함께 빛나는 아름다움을 만듭니다.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              variant="primary" 
              size="lg"
              onClick={handleScrollToProducts}
            >
              제품 둘러보기
            </Button>
            <button 
              onClick={() => {
                const aboutSection = document.getElementById('about');
                if (aboutSection) {
                  aboutSection.scrollIntoView({ behavior: 'smooth' });
                }
              }}
              className="inline-flex items-center justify-center font-medium transition-all duration-200 cursor-pointer whitespace-nowrap border-2 border-emerald-600 text-emerald-600 hover:bg-emerald-600 hover:text-white focus:ring-2 focus:ring-emerald-500 px-8 py-4 text-lg rounded-xl border-white text-white hover:bg-white hover:text-gray-900"
            >
              회사소개 보기
            </button>
          </div>
        </div>
      </div>
      
      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-6 flex items-center justify-center text-white">
          <i className="ri-arrow-down-line text-2xl"></i>
        </div>
      </div>
    </section>
  );
}
